import {
  isPaisRendererDocument,
  isScheduleOfValuesDoc,
} from "../components/permitForms/permitFormHelpers";

export const loadComponent = async (selectedDocument, documentPayload = null) => {
  const schemaType = selectedDocument?.schema_type;

  if (!selectedDocument) {
    return null;
  }

  if (selectedDocument?.is_noc) {
    return await import(`../components/permitForms/global/CreatingNocForm`);
  }

  if (isPaisRendererDocument(selectedDocument, documentPayload)) {
    return await import(`../components/permitForms/SimplePaisForms`);
  }

  if (schemaType === "complex") {
    return await import(`../components/permitForms/DynamicPermitForm`);
  }

  if (!isScheduleOfValuesDoc(selectedDocument)) {
    return await import(`../components/permitForms/SimplePermitForm`);
  }

  return null;
};
